export default __webpack_public_path__ + "static/media/footer-facebook.04891b9d.svg";